export const methodSteps = [
  {
    title: 'Observer',
    text: 'Avant de corriger, on regarde : la respiration, l’appui au sol, la tenue de l’archet. Le geste raconte déjà où se loge la tension.',
  },
  {
    title: 'Comprendre',
    text: 'Chaque difficulté technique a une cause physique. On l’explique simplement, pour que l’élève devienne autonome dans son travail.',
  },
  {
    title: 'Jouer',
    text: 'Le corps libéré, la musique reprend sa place. Le son s’ouvre, l’interprétation gagne en liberté et en plaisir.',
  },
]

export const lessonFormats = [
  {
    name: 'Cours individuels',
    detail: 'Débutants, amateurs confirmés, étudiants en conservatoire',
    duration: '45 ou 60 min',
  },
  {
    name: 'Cours en ligne',
    detail: 'Suivi régulier à distance, avec retour vidéo entre les séances',
    duration: '45 min',
  },
  {
    name: 'Préparation concert & audition',
    detail: 'Travail ciblé sur un programme, la mise en condition et le trac',
    duration: 'Sur mesure',
  },
]

export const upcomingWorkshops = [
  {
    date: '14 – 15 nov. 2026',
    title: 'Trac & présence scénique',
    audience: 'Tous instrumentistes',
  },
  {
    date: '23 janv. 2027',
    title: 'Le dos, les épaules et l’archet',
    audience: 'Violoncellistes',
  },
  {
    date: '10 – 14 avril 2027',
    title: 'Stage de printemps — musique de chambre',
    audience: 'Cordes, niveau intermédiaire',
  },
]

export const healthTopics = [
  { title: 'Trac et gestion du stress', text: 'Retrouver de la stabilité avant et pendant la scène.' },
  { title: 'Tensions et douleurs', text: 'Identifier les gestes qui fatiguent et les alléger.' },
  { title: 'Posture et ergonomie', text: 'Ajuster l’assise, la pique, l’instrument à votre corps.' },
  { title: 'Organisation du travail', text: 'Pratiquer mieux, sans forcément pratiquer plus.' },
  { title: 'Récupération', text: 'Échauffement, pauses et routines pour durer dans le métier.' },
  { title: 'Reprise après blessure', text: 'Un retour progressif à l’instrument, en confiance.' },
]
